export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const MOODLE_URL = process.env.REACT_APP_MOODLE_URL || 'https://learning.example.com';
